import { Props_SnippetTeamTile } from './TeamTile.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y } from 'swiper/modules';
import SwiperControls, {swiperNavigationOptions, swiperPaginationOptions} from '../Shared/SwiperControls/SwiperControls'

const SnippetTeamTile = (props: Props_SnippetTeamTile) => {
    const { heading, content, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? `snippet-team-tile__heading--${heading.visibility.value}` : ''

    const carouselId = 'snippet-team-tile-carousel'

    return (
    <section className="snippet-team-tile">
        <div className={`snippet-team-tile__container`}>
            <div className={`snippet-team-tile__container-content`}>
                <h2 className={`snippet-team-tile__heading ${classHeadingVisibility}`}>{ heading.content?.value }</h2>
                { content?.content?.value && (
                    <div className={`snippet-team-tile__content`}>
                        { CompileMarkdown(content.content.value) }
                    </div>
                )}
            </div>
            <div className="snippet-team-tile__container-entries">
            { repeatable_entry.map((entry, index: number) => (
                <div key={index} className={`snippet-team-tile__entry`}>
                    { entry.image?.value && (
                        <figure className="snippet-team-tile__entry-image-container">
                            <img
                                className="snippet-team-tile__entry-image"
                                loading="lazy"
                                height={210}
                                width={310}
                                src={entry.image.value}
                                alt={entry.alt?.value ? entry.alt.value : ''}
                            />
                        </figure>
                    )}
                    <div className="snippet-team-tile__entry-content-container">
                        { entry.heading?.value && (
                            <h3 className="snippet-team-tile__entry-title"><a className="snippet-team-tile__entry-title-link" href={entry.linkHref?.value} rel={entry.linkTarget?.value ? 'noopener noreferrer' : undefined} target={entry.linkTarget?.value ? '_blank' : ''}>{ entry.heading.value}</a></h3>
                        )}
                        { entry.content?.value && <div className="snippet-team-tile__entry-content">{ CompileMarkdown(entry.content.value) }</div> }
                        <SnippetLink
                            linkStyles={entry.linkStyle?.value}
                            className="snippet-team-tile__entry-link"
                            url={entry.linkHref?.value}
                            target={entry.linkTarget?.value}
                        >
                            {entry.linkContent?.value}
                        </SnippetLink>
                    </div>
                </div>
            ))}
            </div>
            <div className="snippet-team-tile__container-swiper">
                <Swiper
                    className="snippet-team-tile__swiper"
                    modules={[Navigation, Pagination, A11y]}
                    navigation={{
                        ...swiperNavigationOptions,
                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                    }}
                    pagination={{
                        ...swiperPaginationOptions,
                        el: `.swiper-pagination-${carouselId}`,
                    }}
                    spaceBetween={12}
                    slidesPerView={1}
                    slidesPerGroup={1}
                    watchOverflow={true}
                    watchSlidesProgress={true}
                    breakpoints={{
                        576: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                        },
                        991: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },
                    }}
                >
            { repeatable_entry.map((entry, index: number) => (
                <SwiperSlide key={index} className={`snippet-team-tile__entry`}>
                    { entry.image?.value && (
                        <figure className="snippet-team-tile__entry-image-container">
                            <img
                                className="snippet-team-tile__entry-image"
                                loading="lazy"
                                height={190}
                                width={350}
                                src={entry.image.value}
                                alt={entry.alt?.value ? entry.alt.value : ''}
                            />
                        </figure>
                    )}
                    <div className="snippet-team-tile__entry-content-container">
                        { entry.heading?.value && (
                            <h3 className="snippet-team-tile__entry-title">{ entry.heading.value }</h3>
                        )}
                        { entry.content?.value && <div className="snippet-team-tile__entry-content">{ CompileMarkdown(entry.content.value) }</div> }
                        <SnippetLink
                            linkStyles={entry.linkStyle?.value}
                            className="snippet-team-tile__entry-link"
                            url={entry.linkHref?.value}
                            target={entry.linkTarget?.value}
                        >
                            {entry.linkContent?.value}
                        </SnippetLink>
                    </div>
                </SwiperSlide>
            ))}
                </Swiper>
                <SwiperControls 
                    uniqueId={carouselId} 
                    className="snippet-team-tile__navigation"
                />
            </div>
        </div>
    </section>
    )
}

export default SnippetTeamTile